import { Modal } from "react-bootstrap";

export default function MethodModalPage(props) {
    return (
        <>
            <Modal.Body>
                <div className="col-sm-8 d-flex justify-content-center flex-column gap-4 mx-auto my-2">
                    <button type="button" className="btn btn-dark rounded-pill px-5" data-value="pickup" onClick={props.handleSelectMethodPickupDeliveryModal} /*disabled={props.customerDetailsFormData.validation.ButtonsDisabled}*/>
                        Order for Pickup
                        {/* props.customerDetailsFormData.validation.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> */}                         
                    </button>
                    <button type="button" className="btn btn-dark rounded-pill px-5" data-value="delivery" onClick={props.handleSelectMethodPickupDeliveryModal} /*disabled={props.customerDetailsFormData.validation.ButtonsDisabled}*/>
                        Order for Delivery
                        {/* props.customerDetailsFormData.validation.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> */}                         
                    </button>
                </div>
            </Modal.Body>
        </>
    )
}